/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RateReliefCalculatorServiceResponse,
} from '../models/index';
import {
    RateReliefCalculatorServiceResponseFromJSON,
    RateReliefCalculatorServiceResponseToJSON,
} from '../models/index';

export interface CalculatorApiApiCalculatorGetRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
    rateReliefAmount?: number;
    employeeMedicalEmployee?: number;
    employeeMedicalSpouse?: number;
    employeeMedicalChild?: number;
    employeeMedicalFamily?: number;
    currentPremiumEQ?: number;
    newPremiumEQ?: number;
    estimatedStandardNBRate?: number;
    reissueType?: string;
    override?: number;
    optionsShutoff?: boolean;
}

/**
 * 
 */
export class CalculatorApi extends runtime.BaseAPI {

    /**
     */
    async apiCalculatorGetRaw(requestParameters: CalculatorApiApiCalculatorGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RateReliefCalculatorServiceResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        if (requestParameters['policyNumber'] != null) {
            queryParameters['PolicyNumber'] = requestParameters['policyNumber'];
        }

        if (requestParameters['rateReliefAmount'] != null) {
            queryParameters['RateReliefAmount'] = requestParameters['rateReliefAmount'];
        }

        if (requestParameters['employeeMedicalEmployee'] != null) {
            queryParameters['EmployeeMedicalEmployee'] = requestParameters['employeeMedicalEmployee'];
        }

        if (requestParameters['employeeMedicalSpouse'] != null) {
            queryParameters['EmployeeMedicalSpouse'] = requestParameters['employeeMedicalSpouse'];
        }

        if (requestParameters['employeeMedicalChild'] != null) {
            queryParameters['EmployeeMedicalChild'] = requestParameters['employeeMedicalChild'];
        }

        if (requestParameters['employeeMedicalFamily'] != null) {
            queryParameters['EmployeeMedicalFamily'] = requestParameters['employeeMedicalFamily'];
        }

        if (requestParameters['currentPremiumEQ'] != null) {
            queryParameters['CurrentPremiumEQ'] = requestParameters['currentPremiumEQ'];
        }

        if (requestParameters['newPremiumEQ'] != null) {
            queryParameters['NewPremiumEQ'] = requestParameters['newPremiumEQ'];
        }

        if (requestParameters['estimatedStandardNBRate'] != null) {
            queryParameters['EstimatedStandardNBRate'] = requestParameters['estimatedStandardNBRate'];
        }

        if (requestParameters['reissueType'] != null) {
            queryParameters['ReissueType'] = requestParameters['reissueType'];
        }

        if (requestParameters['override'] != null) {
            queryParameters['Override'] = requestParameters['override'];
        }

        if (requestParameters['optionsShutoff'] != null) {
            queryParameters['OptionsShutoff'] = requestParameters['optionsShutoff'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Calculator`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RateReliefCalculatorServiceResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiCalculatorGet(requestParameters: CalculatorApiApiCalculatorGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RateReliefCalculatorServiceResponse> {
        const response = await this.apiCalculatorGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
